import { SingleSelectField } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { IAttendancePrediction } from "../../../shared/types/invitationList";

type OptionTranslationMap = Record<IAttendancePrediction, string>;

export const useAttendanceTranslations = () => {
	const { t } = useTranslation();
	const translationMap: OptionTranslationMap = {
		will_attend: t("Will attend"),
		will_not_attend: t("Will not attend"),
		unknown: t("Unknown"),
	};
	return translationMap;
};

interface Props {
	required?: boolean;
	disabled?: boolean;
}

export const AttendanceSelectField: FC<Props> = ({ required, disabled }) => {
	const { t } = useTranslation();
	const translationMap = useAttendanceTranslations();

	return (
		<SingleSelectField
			name="attendancePrediction"
			label={t("Attendance prediction")}
			options={Object.keys(translationMap) as IAttendancePrediction[]}
			getLabel={(x) => translationMap[x]}
			clearable={false}
			disabled={disabled}
			required={required}
		/>
	);
};
